import { CanBeAnything } from '../types'

export type EmailCheck =
  | { ok: true } // good e‑mail
  | { ok: false; reason: 'bad-format' } // not even a valid e‑mail
  | { ok: false; reason: 'groupe-domain' } // any “publicisgroupe.net” address
  | { ok: false; reason: 'email-empty' }

export const validateEmail = (email: string): EmailCheck => {
  const simpleEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!email) {
    return { ok: false, reason: 'email-empty' }
  }

  if (!simpleEmail.test(email)) {
    return { ok: false, reason: 'bad-format' }
  }

  const groupeDomain = /@publicisgroupe\.[^\s@]*$/i
  if (groupeDomain.test(email)) {
    return { ok: false, reason: 'groupe-domain' }
  }

  return { ok: true }
}

export const formatTime = (secs: number) => {
  const m = Math.floor(secs / 60)
    .toString()
    .padStart(2, '0')
  const s = (secs % 60).toString().padStart(2, '0')
  return `${m}:${s}`
}

export function formatDateToReadable(input: string): string {
  const date = new Date(input)

  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }

  return date.toLocaleString('en-US', options).replace(',', '')
}

export const downloadFile = (fileUrl: string, fileName = 'downloaded-file') => {
  const link = document.createElement('a')
  link.href = fileUrl
  link.setAttribute('download', fileName) // This sets the filename
  link.setAttribute('target', '') // Optional: open in new tab
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const scrollToOffset = (
  el: { getBoundingClientRect: () => { (): CanBeAnything; new (): CanBeAnything; top: number } },
  offset = 0
) => {
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset
  window.scrollTo({ top, behavior: 'smooth' })
}
